import { randomUUID } from "../../axios_with_token";
import "./Arrays.css";
import { useRef, useState } from "react";
import { VAL_DELETED } from "../../consts";
import IconRedo from "../../assets/images/arrow-clockwise.svg";
import IcoUndo from "../../assets/images/arrow-counterclockwise.svg";

function convertToJson(valIn){
    let val = valIn || '[]';
    let valJson = [];
    try{
        valJson = (val.constructor == String)?JSON.parse(val):val;
    }catch(err){
        
    }
    return valJson;
}

export default function Arrays({fldName, form, fldDef, opts}){
    const refData = useRef({
        history: {
            cache: [],
            idx: -1
        },
    });
    const fldVal =  convertToJson(form.getValues()[fldName]);
    const [src, setSrc] = useState(fldVal);
    const [_, forceRefresh] = useState();
    const refItemLen = useRef();
    const regedNames = {};
    const formReg = (regName, formOpts)=>{
        regedNames[regName] = true;
        return form.register(regName, formOpts);
    }
    const valuesToSrc = _=>{
        const values = form.getValues();
        src.forEach((srcItem, rowIdx)=>{
            srcItem.forEach((srcItemFld, colIdx)=>{
                src[rowIdx][colIdx] = values[`${fldName},${rowIdx},${colIdx}`];
            })
        });
    }
    const srcToValues = srcIn=>{
        const newSrc = srcIn || src;
        Object.keys(regedNames).forEach(regName=>{
            form.setValue(regName, VAL_DELETED);
        })

        newSrc.forEach((srcItem, rowIdx)=>{
            srcItem.forEach((srcItemFld, colIdx)=>{
                form.setValue(`${fldName},${rowIdx},${colIdx}`, newSrc[rowIdx][colIdx]);
            })
        })
    }
    const history = refData.current.history;
    const pushInHistory = srcIn=>{
        valuesToSrc();
        history.cache.length = Math.max(history.idx+1, 0);
        history.cache.push([...(srcIn||src)]);
        history.idx=history.cache.length - 1;
        console.log('history:', history);
        forceRefresh(randomUUID());
    }
    const undo = _=>{
        history.idx = Math.max(0, history.idx - 1);
        const newSrc = history.cache[history.idx];
        if(!newSrc)return;

        srcToValues(newSrc);
        setSrc(newSrc);
    }
    const redo = _=>{
        history.idx = Math.min(history.cache.length, history.idx + 1);
        const newSrc = history.cache[history.idx];
        if(!newSrc)return;

        srcToValues(newSrc);
        setSrc(newSrc);
    }

    return <div>
        {/* <input type="hidden" {...form.register(fldName, opts.formOpts)} /> */}
        <div>
            <button type="button" className="btn btn-sm btn-primary"
                title="add new item"
                onClick={evt=>{
                    pushInHistory();

                    const newItem = " ".repeat(refItemLen.current?refItemLen.current.value:3).split("").map(_=>'');
                    setSrc([...src, newItem])
                    newItem.forEach((_, colIdx)=>{
                        form.setValue(`${fldName},${src.length},${colIdx}`, '');
                    });
                }}
            >+</button>
            <select className="btn btn-sm"
                defaultValue={((src||[])[0]||[]).length || 2}
                ref={refItemLen}
                title="set column number"
                onChange={evt=>{
                    pushInHistory();

                    const tmpNewSrc = [...src];
                    const newSrc = tmpNewSrc.map(srcItem=>{
                        const newsrcItem = [...srcItem]
                        newsrcItem.length = evt.target.value;
                        return [...newsrcItem]
                    });

                    srcToValues(newSrc);
                    setSrc(newSrc);
                }}
            >
                {'_'.repeat(15).split('').map((_, itemLenIdx)=><option
                    key={itemLenIdx}
                >{itemLenIdx+1}</option>)}
            </select>


            <button type="button" className="btn btn-sm btn-primary ms-1"
                title="undo"
                disabled={history.idx>0?false:true}
                onClick={evt=>undo()}
            ><img className="mt-2" src={IcoUndo} /></button>
            <button type="button" className="btn btn-sm btn-primary"
                title="redo"
                disabled={(history.cache.length>(history.idx+1))?false:true}
                onClick={evt=>redo()}
            ><img className="mt-2" src={IconRedo} /></button>
            
        </div>
        <table className="table table-sm">
            <tbody>
                {
                    src.map((srcItem, rowIdx)=>{
                        const srcItemFlds = convertToJson(srcItem);
                        const rowId=randomUUID();
                        return <tr key={randomUUID()}>
                            {srcItemFlds.map((srcItemFld, colIdx)=><td
                                key={randomUUID()}
                            >
                                <input type="text" defaultValue={srcItemFld} className="form-control form-control-sm"
                                    {...formReg(`${fldName},${rowIdx},${colIdx}`, opts.formOpts)}
                                ></input>
                            </td>)}
                            <td>
                                <div className="btn-group" role="group">
                                    <button type="button" className="btn btn-sm btn-warning"
                                        onClick={
                                            ((rowIdx, colFlds)=>evt=>{
                                                pushInHistory();

                                                // [] this will cause root refresh
                                                const values = form.getValues();
                                                for(let i=rowIdx, l=src.length-1; i<l; i++){
                                                    colFlds.forEach((fld, colIdx)=>{
                                                        form.setValue(`${fldName},${i},${colIdx}`, values[`${fldName},${i+1},${colIdx}`]);
                                                    });
                                                }
                                                colFlds.forEach((fld, colIdx)=>{
                                                    form.setValue(`${fldName},${src.length-1},${colIdx}`, VAL_DELETED);
                                                    // delete values[`${fldName},${src.length-1},${colIdx}`];
                                                });
                                                form.setValue(fldName, '');
                                                const newSrc = [...src];
                                                newSrc.splice(rowIdx, 1);
                                                setSrc(newSrc);
                                            })(rowIdx, srcItemFlds)
                                        }
                                    >X</button>
                                    <button type="button" className="btn btn-sm btn-primary"
                                    >U</button>
                                    <button type="button" className="btn btn-sm btn-primary"
                                    >D</button>
                                </div>

                            </td>
                        </tr>;
                    })
                }
            </tbody>
        </table>
    
    </div>;
}